const state = {
  faq: [
    {
      category: 'Category Title',
      description: 'Description category 1, lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
      content: [
        {
          question: 'Question 1.1',
          answer: 'Answer 1.1, lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum'
        },
        {
          question: 'Question 1.2',
          answer: 'Answer 1.2'
        },
        {
          question: 'Question 1.3',
          answer: 'Answer 1.3'
        }
      ]
    },
    {
      category: 'Category Title',
      description: 'Description category 2, lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
      content: [
        {
          question: 'Question 2.1',
          answer: 'Answer 2.1'
        },
        {
          question: 'Question 2.2',
          answer: 'Answer 2.2'
        },
        {
          question: 'Question 2.3',
          answer: 'Answer 2.3'
        }
      ]
    },
    {
      category: 'Category Title',
      description: 'Description category 3, lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum lorem ipsum',
      content: [
        {
          question: 'Question 3.1',
          answer: 'Answer 3.1'
        },
        {
          question: 'Question 2.2',
          answer: 'Answer 3.2'
        },
        {
          question: 'Question 2.3',
          answer: 'Answer 3.3'
        }
      ]
    }
  ]
}
const getters = {}
const actions = {}
const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}
